"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetToolbar = void 0;
var react_1 = __importDefault(require("react"));
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var useSelectionState_1 = require("./useSelectionState");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var inversify_react_1 = require("inversify-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var WidgetToolbar = function (_a) {
    var element = _a.element, anchorElement = _a.anchorElement;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type);
    var WidgetButtons = config === null || config === void 0 ? void 0 : config.toolbarButtons;
    var styleableConfig = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: element.type, traitName: "styleable" });
    return (react_1.default.createElement(kaleidoscope_1.Toolbar, { element: anchorElement, visible: widgetSelectionState === "circle", positionType: kaleidoscope_1.ToolbarPositionType.Element },
        WidgetButtons ? react_1.default.createElement(WidgetButtons, { element: element }) : null,
        styleableConfig ? (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Styles, null) })); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" }, styleableConfig.properties.map(function (property) {
                var _a, _b, _c;
                if (property.type === "color") {
                    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                        react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark" }, property.label),
                        react_1.default.createElement(ColorPalette_1.default, { key: property.name, onColorChange: function (color) {
                                var _a;
                                var _b;
                                blockStore.blockStyleStore.setStyleAttribute(styleableConfig.styleKey, __assign(__assign({}, ((_b = blockStore.blockStyleStore.model[styleableConfig.styleKey]) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[property.name] = color, _a)));
                            }, presetColors: brandStore.colorsWithThemeIndex, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((_c = (_b = (_a = blockStore.blockStyleStore.model[styleableConfig.styleKey]) === null || _a === void 0 ? void 0 : _a[property.name]) !== null && _b !== void 0 ? _b : {
                                themeIndex: 0,
                            }) !== null && _c !== void 0 ? _c : undefined, brandStore.colorsWithThemeIndex), type: "content" })));
                }
                else {
                    throw new Error("Unsupported property type");
                }
            })))) : null,
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Delete, null), tooltip: { content: "delete" }, onClick: function () {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                    action: "delete",
                    path: widgetManager.getPath(element),
                    type: element.type,
                }));
            }, isDestructive: true })));
};
exports.WidgetToolbar = WidgetToolbar;
